import { Button, Link, useDeviceType } from '@packages/shared';
import { ArrowMediumLeft32 } from '@packages/themes/icons';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import type { BreadcrumbsFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { extendedBreadcrumbsMessages } from '../messages';

export type ExtendedBreadcrumbsBackButtonProps = {
  breadCrumbData: BreadcrumbsFragmentFragment['breadCrumb'];
};

export const ExtendedBreadcrumbsBackButton = ({
  breadCrumbData,
}: ExtendedBreadcrumbsBackButtonProps) => {
  const { formatMessage } = useIntl();

  const searchParams = useSearchParams();
  const { isMobile } = useDeviceType();

  const hasBreadcrumb = breadCrumbData && breadCrumbData.length > 0;

  const [rememberedBackLink, setRememberedBackLink] = useState<string>(
    hasBreadcrumb
      ? breadCrumbData[breadCrumbData.length - 1].uriPath
      : `/s/${searchParams?.get('nav-q') || ''}`,
  );

  useEffect(() => {
    const pageData = window.sessionStorage.getItem('rememberedPageData');
    if (pageData) {
      const rememberedData = JSON.parse(pageData);
      setRememberedBackLink(rememberedData.path);
    }
  }, []);

  let buttonText = '';

  if (hasBreadcrumb) {
    if (isMobile) {
      buttonText = `${formatMessage(extendedBreadcrumbsMessages.backToLastCategory)} ${breadCrumbData[breadCrumbData.length - 1].name}`;
    } else {
      buttonText = formatMessage(extendedBreadcrumbsMessages.backToMBA);
    }
  } else {
    buttonText = formatMessage(extendedBreadcrumbsMessages.backToSERP);
  }

  return (
    <Button
      LinkComponent={Link}
      href={rememberedBackLink}
      startIcon={<ArrowMediumLeft32 />}
      sx={{ whiteSpace: 'nowrap' }}
      variant="text"
    >
      {buttonText}
    </Button>
  );
};
